import http from './../../../base/api/public'
let sysConfig = require('@/../config/sysConfig')
let service = require('@/../config/serviceList')
let apiPre = sysConfig.apiPre
export default {
     // 电表启动配置分页
     getMeterConfigPage(params) {
       console.log('params:' + JSON.stringify(params))
       return http.requestPost(apiPre + service.res + '/res/acquisition/queayAll', params)
     },
     deleteMeterConfig(params) {
       console.log('params:' + JSON.stringify(params))
       return http.requestGet(apiPre + service.res + '/res/acquisition/deleteAll?id='+ params)
     },
     inOrUpdate(params) {
       console.log('params:' + JSON.stringify(params))
       return http.requestPost(apiPre + service.res + '/res/acquisition/insertOrUpdate', params)
     },
     alarmStationAll(params) {
       return http.requestPost(apiPre + service.res + '/res/station/stationsForSelectByOperatorId',params)
     },
     getlistForSelectTree(params){
       return http.requestPost(apiPre + service.member +'/member/operator/listForSelectTree',params)
     },
     manualMeterReading(params) {
       console.log('params:' + JSON.stringify(params))
       return http.requestGet(apiPre + service.res + '/res/meter/manualMeterReading/'+ params)
     },
  }



// WEBPACK FOOTER //
// ./src/module/resourceCenter/api/meterConfigurationApi.js